import Reveal from '@/components/Reveal';

const PRINCIPLES: Array<{ meta: string; title: string; body: string }> = [
  {
    meta: '0 % с оборота',
    title: 'Зарабатываете вы, не платформа',
    body: 'Платежи идут напрямую через ваш счёт в ЮKassa или СБП. Resstro не стоит в цепочке денег.',
  },
  {
    meta: '152-ФЗ · 54-ФЗ',
    title: 'Серверы и данные в России',
    body: 'Дата-центр в РФ, шифрование, ежедневные резервные копии. Чеки по 54-ФЗ из коробки.',
  },
  {
    meta: 'Бесплатно',
    title: 'Перенос с iiko, r_keeper, Poster',
    body: 'Заберём меню, тех-карты и историю заказов. Запустим параллельно, без простоя зала.',
  },
  {
    meta: 'В один клик',
    title: 'Отмена без удержаний',
    body: 'Без звонков менеджеру и переписки. Данные храним 90 дней, вернётесь, когда удобно.',
  },
];

export default function SocialProof() {
  return (
    <section className="section section-divider">
      <div className="container-site">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-6">
            <Reveal>
              <h2 className="h2">Прозрачно с&nbsp;первого дня. Без&nbsp;звёздочек.</h2>
            </Reveal>
          </div>
          <Reveal delay={80} className="md:col-span-5 md:col-start-8 md:pt-10">
            <p className="lead">
              Resstro делает команда, которая сама работала в&nbsp;ресторане. Всё, что ниже,
              мы&nbsp;гарантируем письменно в&nbsp;оферте.
            </p>
          </Reveal>
        </div>

        <Reveal delay={120}>
          <ul className="mt-16 divide-y divide-line border-y border-line sm:mt-20">
            {PRINCIPLES.map((p) => (
              <li key={p.title} className="grid gap-3 py-8 sm:grid-cols-12 sm:gap-8 sm:py-10">
                <h3 className="text-[22px] font-medium leading-snug tracking-tight text-ink sm:col-span-4">
                  {p.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-ink/60 sm:col-span-5">{p.body}</p>
                <span className="num text-[15px] font-medium text-ink/60 sm:col-span-3 sm:text-right">{p.meta}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
